export default __webpack_public_path__ + "static/media/Bootstrap.ff93b99e.png";